import { Box, Grid, TextField, Typography, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export const TrabajaConNosotros = () => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [fileName, setFileName] = useState(t("cargar_curriculum"));
  const [file, setFile] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setFileName(selected.name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);

    const formData = new FormData(formRef.current);
    if (file) {
      formData.append("cv", file);
    }

    try {
      const response = await fetch("https://usebasin.com/f/22c4fa7881e0", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Formulario enviado con éxito");
        formRef.current.reset();
        setFileName(t("cargar_curriculum"));
        setFile(null);
      } else {
        alert("Error al enviar. Intentalo de nuevo.");
      }
    } catch (error) {
      console.error(error);
      alert("Error de conexión.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "center", md: "flex-start" },
        justifyContent: "space-between",
        px: { xs: 3, sm: 6, md: 10 }, // más padding lateral
        py: { xs: 6, sm: 8, md: 10 }, // más espacio arriba y abajo
        gap: { xs: 6, md: 8 }, // más separación entre texto y formulario
      }}
    >
      {/* Texto descriptivo */}
      <Box
        sx={{
          flex: 1,
          textAlign: { xs: "center", md: "left" },
          maxWidth: { xs: "100%", md: "40%" },
        }}
      >
        <Typography
          sx={{
            color: "#FFF",
            fontFamily: "Montserrat",
            fontSize: { xs: "32px", sm: "40px", md: "53px" },
            fontWeight: 800,
            lineHeight: "125%",
          }}
        >
          {t("trabaja_con_nosotros_titulo")}
        </Typography>
        <Typography
          sx={{
            color: "#6EB1D9",
            fontFamily: "Montserrat",
            fontSize: { xs: "16px", sm: "18px", md: "21px" },
            fontWeight: 700,
            lineHeight: "137.5%",
            mt: 2,
          }}
        >
          {t("trabaja_con_nosotros_subtitulo")}
        </Typography>
        <Typography
          sx={{
            color: "#FFF",
            fontFamily: "Montserrat",
            fontSize: { xs: "14px", sm: "16px", md: "20px" },
            fontWeight: 400,
            lineHeight: "140%",
            mt: 2,
          }}
        >
          {t("trabaja_con_nosotros_parrafo")}
        </Typography>
      </Box>

      {/* Formulario */}
      <Box
        sx={{
          flex: 1,
          width: "100%",
          maxWidth: { xs: "100%", md: "55rem" },
          marginTop: "-2rem"
        }}
      >
        <form ref={formRef} onSubmit={handleSubmit}>
          <Grid
            container
            spacing={2}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              borderRadius: 2,
              color: "white",
            }}
          >
            <Grid item xs={12} md={6}>
              <TextField
                name="nombre"
                fullWidth
                label={t("nombre_y_apellido")}
                variant="outlined"
                sx={textFieldStyles}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="email"
                fullWidth
                label={t("mail")}
                variant="outlined"
                sx={textFieldStyles}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="mensaje"
                fullWidth
                label={t("mensaje")}
                multiline
                rows={7}
                variant="outlined"
                sx={textFieldStyles}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  alignItems: "flex-start",
                }}
              >
                <TextField
                  name="telefono"
                  fullWidth
                  label={t("telefono")}
                  variant="outlined"
                  sx={textFieldStyles}
                />

                <label htmlFor="cv-upload">
                  <input
                    type="file"
                    id="cv-upload"
                    name="cv"
                    accept="application/pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <Button
                    component="span"
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                    sx={uploadButtonStyle}
                  >
                    {fileName}
                  </Button>
                </label>

                <Button
                  type="submit"
                  variant="contained"
                  disabled={enviando}
                  sx={{
                    backgroundColor: "#6EB1D9",
                    borderRadius: "14px",
                    px: { xs: 3, md: 4 },
                    py: { xs: 1.5, md: 2 },
                    color: "#1B2466",
                    textAlign: "center",
                    fontFamily: "Montserrat",
                    textTransform: "none",
                    fontSize: { xs: "14px", md: "15px" },
                    fontWeight: 500,
                  }}
                >
                  {enviando ? t("enviando") : t("enviar")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

const textFieldStyles = {
  backgroundColor: "transparent",
  input: { color: "white" },
  "& .MuiInputBase-input": {
    color: "white",
  },
  "& .MuiInputLabel-root": {
    color: "#FFF",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#FFF",
      borderRadius: "14px",
    },
    "&:hover fieldset": { borderColor: "#FFF" },
    "&.Mui-focused fieldset": { borderColor: "#FFF" },
  },
};

const uploadButtonStyle = {
  width: "100%",
  maxWidth: "13rem",
  height: "3rem",
  backgroundColor: "#D9D9D9",
  color: "#1B2466",
  textAlign: "justify",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontWeight: 600,
  borderColor: "#D9D9D9",
  borderRadius: "11px",
  textTransform: "none",
};
